import RouteComponent from "./Components/Routes/RouteComponent.js";
import "./App.css";

function App() {
  return (
    <div className="App">
      <RouteComponent />
    </div>
  );
}

export default App;
